<template>
    <div class="panel__container">
        <h2 class="panel__title">Add people</h2>

        <form @submit.prevent="save()" action="" method="post" class="lc-integrations-form form">
            <div class="form__group" :class="{ 'form__group--error' : form.errors.has('name')}">
                <user-lookup id="members" v-model="form.users" :placeholder="`Search for people within the ${tenant.display_name} workspace...`" :users="users" :prevent-hit="preventSelecting">
                    <template v-slot:result="{ item }">
                        <slot name="result" :item="item">
                            <avatar :user="item"></avatar>
                            <strong>{{ item.is_pending ? 'Pending - ' + item.email : item.display_name }}</strong>
                            <small v-if="isChannelMember(item)">Already in this channel</small>
                            <small v-else-if="isSingleChannelGuestWithChannel(item)">Single channel guest from other channel</small>
                        </slot>
                    </template>
                    <template v-slot:selected="{ item }">
                        <slot name="selected" :item="item">
                            <avatar :user="item"></avatar> {{ item.is_pending ? `Pending - ${item.email}` : item.display_name }}
                        </slot>
                    </template>
                </user-lookup>
            </div>
            <footer class="panel__footer">
                <a @click.prevent="goBack" href="#" class="button button--small button--link">Cancel</a>
                <button type="submit" class="lc-submit button button--primary button--small" :disabled="saveDisabled">Save</button>
            </footer>
        </form>
    </div>
</template>

<script>
/* global EventBus */
import { mapGetters, mapState } from 'vuex'
import UserLookup from '../../../Global/UserLookup'
import Avatar from '../../../Global/Avatar'
import Form from '../../../../helpers/Form'
export default {
    data () {
        return {
            form: new Form({
                users: []
            })
        }
    },
    methods: {
        save () {
            this.$store.dispatch('channel/addMembers', this.form).then(() => {
                this.$router.push({ path: `/channel/${this.channel.slug}/settings/people/` })
                EventBus.$emit('newSnackbar', 'People added')
            })
        },

        goBack () {
            this.$router.push({ path: `/channel/${this.channel.slug}/settings/people/options` })
        },

        isChannelMember (user) {
            return this.channelUserIds.includes(user.id)
        },

        isSingleChannelGuestWithChannel (item) {
            return item.is_single_channel_guest && item.channels.length > 0
        },

        preventSelecting (item) {
            return this.isChannelMember(item) || this.isSingleChannelGuestWithChannel(item)
        }
    },
    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapState('channel', ['channel', 'members']),

        ...mapState('tenant', ['tenant']),

        ...mapGetters({
            users: 'tenant/sortedUsers'
        }),

        channelUserIds () {
            return this.members.map(user => user.id)
        },

        saveDisabled () {
            return this.form.busy || this.form.users.length === 0
        }
    },
    components: {
        UserLookup,
        Avatar
    }
}
</script>
